// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"11452bc8","344":"f1f55809","559":"878672d2","791":"96ea4f6c","814":"c8feca58"}[chunkId] + ".chunk.js";
};